import { render, staticRenderFns } from "./LargeImage.vue?vue&type=template&id=94a48580"
import script from "./LargeImage.vue?vue&type=script&lang=ts"
export * from "./LargeImage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports